module.exports = __webpack_public_path__ + "img/ttshop_dsh1.207f4310.svg";